import { render } from "./WidgetsPanelButton.vue?vue&type=template&id=30bf4e60&scoped=true"
import script from "./WidgetsPanelButton.vue?vue&type=script&lang=ts"
export * from "./WidgetsPanelButton.vue?vue&type=script&lang=ts"

import "./WidgetsPanelButton.vue?vue&type=style&index=0&id=30bf4e60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30bf4e60"

export default script